<template>
  <div class="Codes">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Bloquear horarios</p>
        <div class="b-c">
          <p class="o-b">Selecciona una fecha </p>
              <div class="row"> 
                <div class="col-md-5">
                  <datepicker style="margin: 0 auto;" :highlighted="highlighted" :disabledDates="disabledDates" @selected="getHour()" format="MM/DD/YYYY" :monday-first="true" class="calendar" v-model="fecha" name="date" :inline="true" :language="es"></datepicker>
                  <p class="error" v-if="errors != ''">
                    <ul>
                      <li>{{ errors }}</li>
                    </ul>
                  </p>
                </div>
                <div class="col-md-7">
                  <div class="a-l">
                    <ul>
                        <li v-for="opt in hours" :key="opt.id">
                          <button v-on:click="hourSelected(opt.timestamp, opt.blocked, opt), activeBtn = opt.timestamp" class="o-l" v-bind:class="{'btn-active-bloq': opt.blocked === true, 'btn-active-bloq-s': activeBtn === opt.timestamp}" >{{opt.formatted.split('-')[1]}} {{opt.id}}</button>
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>

import BlockedSchedule from '../parse/models/BlockedSchedule'
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'
import Service from '../parse/models/Service'

var state = {
  date: new Date(2016, 9,  16)
}

export default {
  name: 'Codes',
  components: {
    Datepicker,
  },
  data () {
    return {
      activeBtn: '',
      hours:[], 
      hourSelect: '',
      fecha: '',
      hour: '',
      errors: '',
      dateObject:{},

      codeGral: 0,
      activeUR: true,
      nombre: "",
      descripcion: "",
      descuento: "",
      cantidad: "",
      date:"",
      en: en,
      es: es,
      datese: "",
  
      available: 0,
      used: 0,

      formData: {
        nombre: "",
        descripcion: "",
        descuento: "",
        cantidad: "",
        fecha: "",
        nuevosUsuarios: 0,
        reutilizable: 0
      },
      daySelected: "",
      highlighted: {
          dates: [
            new Date(Date.now())
          ]
      },
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      }
    }
  },

  beforeMount() {
    
    this.fecha = new Date(Date.now())
    BlockedSchedule.getHours(this.fecha).then((hours) => {
      this.hours = hours
      this.daySelected = hours[0].date
    })
  },

  methods: {
    
    getHour(e){
      this.$nextTick(() => 
        BlockedSchedule.getHours(this.fecha).then((hours) => {
          this.hours = hours
          this.daySelected = hours[0].date
        }
      ))     
    },

    hourSelected(opt, status, id){

      this.hour = opt
      if(this.fecha == '' || this.hour == ''){
        this.errors = "Selecciona una fecha y hora"
        return
      }

      this.errors = ""
    
      if (status == false){
      this.$swal({
          title: 'Espera',
          text: '¿Estás seguro de bloquear este horario?',
          type: 'warning',
          confirmButtonText: 'bloquear',
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then(result => {
          if(result.value) {
            this.$swal('', 'Horario bloqueado', 'success')
            BlockedSchedule.blockedHours(this.hour).then((result) => {
              this.reloadTable()
            })
          } else {
            this.$swal('', 'Cancelado', 'info')
          }
        });
      } else {
        this.$swal({
          title: 'Espera',
          text: '¿Estás seguro de que desbloquear el horario?',
          type: 'warning',
          confirmButtonText: 'Desbloquear',
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then(result => {
          if(result.value) {
            this.$swal('', 'Horario habilitado', 'success')
              BlockedSchedule.changeStatus(id)
              .then((code) => 
                code.destroyObject(code)
                .then(result =>  this.reloadTable()))
                .catch(error => console.log(error))
              .catch(error => console.log(error))
          } else {
            this.$swal('', 'Cancelado', 'info')
          }
        });
      }
    },

    reloadTable(){
      this.activeBtn = ""
      this.hours = [] 
      console.log(this.daySelected)

      BlockedSchedule.getHours(this.daySelected).then((hours) => {
        this.hours = hours
        this.daySelected = hours[0].date
      })
    },
  
    changeStatus(id){
      this.$swal({
          title: 'Espera',
          text: '¿Estás seguro de que desbloquear el horario?',
          type: 'warning',
          confirmButtonText: 'Desbloquear',
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then(result => {
          if(result.value) {
            this.$swal('', 'Horario habilitado', 'success')
              BlockedSchedule.changeStatus(id)
              .then((code) => this.reloadTable())
              .catch(error => console.log(error))
          } else {
            this.$swal('', 'Cancelado', 'info')
          }
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .btn-active-bloq{
    background: #e36969 !important;
    cursor: default;
    color: #fff !important;
  }

  .btn-active-bloq-s{
    background: #e36969 !important;
    cursor: default;
    color: #fff !important;
  }

  .vdp-datepicker__calendar{
    margin: 0 auto !important;
  }

  .calendar > .my-datepicker_calendar {
    width: 100%;
    height: 130px;
  }
  
  .a-relative{
    position: relative;
  }

  .a-relative button{
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .d-i{
    display: inline-block;
    margin-right: 20px;
  }

  .c-t-info{
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }

  .c-t-info-h-active{
    height: auto;
    max-height: 600px;

  }

  /* USER INFO */
  .img_user{
    width: 138px;
    height: 138px;
    border-radius: 70px;
    float: left;
    margin-right: 20px;
  }

  .info-u{
    display: inline;
  }

  .info-ac button{
    display: inline;
  }

  table tbody tr{
    background: #F3F3F3;
  }

  .but-r{
    background: #E96369;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }

  .but-c{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 270px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-c:hover{ 
    background: #14fc78;
  }
  
  

  .m-r{
    margin-right: 50px;
  }

  .dropdown-menu{
    width: 120px;
  }

  /* Container */
  
  .content-info{
    margin-left: 310px;
    margin-right: 50px;
  }

  .c-i-c{
    width: 250px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .c-i-c-t{
    width: 200px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .t-u-c{
    padding-top: 14px;
    color: #fff;
    font-size: 16px;
  }

  .b-c {
    margin-right: 50px;
    margin-top: 37px;
    border: 1px solid #f6f6f6;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    -moz-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    padding: 15px;
  }

  .sub-t{
    font-size: 18px;
    display: inline;
  }

  .i-f-s{
    width: 25px;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-f-g{
    background: #f3f3f3;
    border: none;
    padding: 10px;
    height: 40px;
    width: 100%;
    border-radius: 10px;
  }

  .but-g{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    margin: 20px 0 0 0;
  }
  .but-g:hover{ 
    background: #14fc78;
  }

  .but-b{
    background: #000;
    color: #fff;
    border: 0;
    width: 200px;
    height: 40px;
    border-radius: 10px;
  }
  .but-b:hover{ 
    background: rgb(27, 27, 27);
  }


  .btn-f{
    margin: 0 40px 0 20px;
  }

  .f-r{
    float: right;
  }

  .s-o{
    background: #f3f3f3;
    border: none;
    font-family: "Open regular";
    font-size: 16px;
    padding: 5px;
    width: 200px;
  }

  .s-o option{
    padding: 5px;
  }

  .table{
    border: 1px solid #f6f6f6;
    text-align: center;
  }
  .btn-actions{
    background: #f6f6f6;
    border: none;
  }

  .o-l{
    border: 1px solid #646464;
    border-radius: 10px;
    font-family: 'Work Sans regular', Helvetica, Arial, sans-serif;
    font-size: 10px;
    height: 40px;
    width: 90px;
    background: #000;
    color: #fff;
    margin-top: 10px
  }

  .o-l:hover{
    background: #fff;
    color: #000;
  }


  .a-l ul {
    overflow: auto;
    overflow-y: hidden;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .a-l li {
    display: inline;
    vertical-align: top;
    margin-right: 1%;
  }

  /*
  * Error 
  */

  .error {
    color: red;
    font-size: 12px;
    display: block;
  }

  .error ul {
    padding: 0;
    list-style: none;
  }

</style>
